import React, { FunctionComponent, PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { DeeplinkKey } from '../../config/Constants';
import { Storage } from '../../utils/Storage';

export const Deeplink: FunctionComponent<PropsWithChildren<{}>> = ({
  children,
}) => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== '/logout') {
      Storage.set(DeeplinkKey, location.pathname);
    }
  }, []);

  return <>{children}</>;
};
